module.exports = __webpack_public_path__ + "static/media/18import-41.7cf87661.xlsx";